<template>
  <eagle-list
    :list-key="listKey"
  ></eagle-list>
</template>

<script lang="babel" type="text/babel">
import listMixin from '@/components/list/mixins/listMixin'
import listConfig from './videoListConfig'
export default {
  mixins: [listMixin],
  data: () => ({
    listKey: 'video-list',
    meta: {},
  }),
  methods: {
    async beforeIndex() {
      await Promise.all([])
    },
    async indexApi(params) {
      return await this.$api.collection.videoApi.index(params)
    },
    async patchApi(value, row, config) {
      const target = row.id
      const column = config.key
      return await this.$api.collection.videoApi.patch(target, column, value)
    },
    async deleteApi(target) {
      return await this.$api.collection.videoApi.delete(target)
    },
    async batchApi(targets, column, value) {
      return await this.$api.collection.videoApi.batch(targets, column, value)
    },
    async batchDeleteApi(targets) {
      return await this.$api.collection.videoApi.batchDelete(targets)
    },
    getListConfig() {
      return listConfig
    },
  },
}
</script>

<style lang="sass" type="text/sass" scoped></style>
